<template>
	<div class="container">
		<div class="main">
			<div>
				<h4>短信套餐</h4>
				<el-form>
					<el-form-item label="已使用/总量" prop="">
						<el-tag>{{ sms.used }}/{{ sms.total }}</el-tag>
					</el-form-item>
				</el-form>
				<div class="top">
					<el-button size="small" type="primary" icon="el-icon-shopping-cart-2" @click="buy">短信购买</el-button>
					<!--					<el-button size="small" type="primary" icon="el-icon-edit" @click="dialog2=true">推送手机号</el-button>-->
				</div>
				<div class="top">
					<el-button size="small" type="primary" icon="el-icon-document" plain @click="buyLog">购买记录
					</el-button>
					<el-button size="small" type="primary" icon="el-icon-document" plain @click="sendLog">发送记录
					</el-button>
				</div>
			</div>
			<div class="list">
				<h4>{{ logType === 0 ? '短信购买记录' : '短信发送记录' }}</h4>
				<el-table v-loading="listLoading" :data="list" v-show="logType===0" element-loading-text="正在查询中。。。"
						  border fit highlight-current-row>
					<el-table-column align="center" label="ID" prop="id" width="80"/>
					<el-table-column align="center" label="购买数量" prop="buy_num"/>
					<el-table-column align="center" label="支付金额（元）" prop="buy_money"/>
					<el-table-column align="center" label="支付时间" prop="create_time" width="160"/>
					<el-table-column align="center" label="支付单号" prop="sms_order_num" width="300"/>
				</el-table>
				<el-table v-loading="listLoading" :data="list" v-show="logType===1" element-loading-text="正在查询中。。。"
						  border fit highlight-current-row>
					<el-table-column align="center" label="ID" prop="id" width="80"/>
					<el-table-column align="center" label="手机号码" prop="account" width="160"/>
					<el-table-column align="center" label="短信发送内容" prop="message_content" min-width="160"/>
					<el-table-column align="center" label="发送数量" prop="send_count" width="80"/>
					<el-table-column align="center" label="发送时间" prop="create_time" width="160"/>
				</el-table>
				<div>
					<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
								   :current-page="listQuery.pageindex" :page-sizes="[10, 20, 30, 40]"
								   :page-size="listQuery.pagesize"
								   layout="total,  prev, pager, next, jumper"
								   :total="total"
								   style="text-align:right;margin:0 16px 10px 0;border-radius:20px"></el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="qrCode?'支付':'套餐选择'" :visible.sync="dialog1" :width="qrCode?'500px':'900px'"
				   @close="dialogClose">
			<div v-show="qrCode" class="qrCode">
				<img :src="qrCode" alt="">
			</div>
			<el-form v-show="!qrCode" ref="formList" :rules="rules" :model="formList" status-icon label-width="70px">
				<el-form-item label="" label-width="0">
					<el-tag type="warning">短信套餐包仅可用于国内文本短信，不包括语音短信和海外短信；其中个人用户仅可用于短信验证码、短信通知等，不可用于营销短信；</el-tag>
					<el-tag type="warning" style="margin-left: 0">
						<span>禁止发送金融相关的所有内容（验证码、通知和营销短信），请客户谨慎购买；</span>
						<span>短信系列产品均不支持使用通用代金券。</span>
					</el-tag>
				</el-form-item>
				<el-form-item label="套餐" prop="packageI">
					<el-radio-group v-model="packageI" @change="selectPackage">
						<el-radio style="margin: 5px 10px 5px 0" v-for="(v,i) in packages" :label="i" border>
							{{ v.num }}万条
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="单价" prop="price">
					<el-tag>{{ formList.price }}</el-tag>
					<span>元</span>
				</el-form-item>
				<el-form-item label="有效期" prop="">
					<el-tag type="info">购买日后24个月有效期，过期销毁资源</el-tag>
				</el-form-item>
				<el-form-item label="短信条数" prop="">
					<el-input-number v-model="formList.num" :precision="1" :step="1" :min=".1"
									 :max="3e3" @change="changeNum"></el-input-number>
					<span>万条</span>
				</el-form-item>
				<el-form-item label="总计费用" prop="money">{{ formList.money }}元</el-form-item>
			</el-form>
			<div v-show="!qrCode" slot="footer" class="dialog-footer">
				<el-button @click="dialog1= false">取 消</el-button>
				<el-button type="primary" @click="ok" :loading="btn1Load">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="推送手机号" :visible.sync="dialog2" width="700px">
			<el-form ref="formList2" :rules="rules2" :model="formList2" status-icon label-width="80px">
				<el-form-item label="手机号码" prop="phone">
					<el-input style="width: 200px" placeholder="请输入手机号码" clearable v-model="formList2.phone"></el-input>
					<el-button size="mini" type="primary" plain @click="addPhone">添加</el-button>
				</el-form-item>
				<el-form-item label="">
					<el-tag style="margin: 0 10px 0 0" closable v-for="(v,i) in formList2.arrPhone"
							@close="delPhone(i)">{{ v }}
					</el-tag>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialog2= false">取 消</el-button>
				<el-button type="primary" @click="save">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import api from "../../api/card";

let timeout;
export default {
	name: 'sms',
	data() {
		return {
			dialog1: false,
			dialog2: false,
			btn1Load: false,
			list: [],
			logType: 1,
			listLoading: false,
			total: 0,
			listQuery: {
				pageindex: 1,
				pagesize: 10,
				count:true
			},
			qrCode: '',
			packageI: '',
			formList: {num: 0.1, money: 96, price: 0.096},
			formList2: {phone: '', arrPhone: []},
			sms: {used: 0, total: 0},
			packages: [{num: 1}, {num: 5}, {num: 10}, {num: 50}, {num: 100}, {num: 300}],
			rules: {},
			rules2: {
				phone: [{required: true, message: '手机号不能为空', trigger: 'blur'},
					{pattern: /^1[3-9][0-9]{9}$/, message: '手机号格式不对', trigger: 'blur'}]
			},
		}
	},
	created() {
		this.init();
		this.logList();
	},
	methods: {
		init() {
			api.getSms().then(res => {
				this.sms = {
					used: res.sms_used,
					total: res.sms_total,
				}
				this.formList2.arrPhone = res.send_phone ? res.send_phone.split(',') : [];
			})
		},
		selectPackage(i) {//选择套餐
			let price = this.getPrice(i + 1);
			this.formList.money = price * this.packages[i].num;
			this.formList.price = price / 1e4;
			this.formList.num = this.packages[i].num;
		},
		changeNum(num) {
			let type = this.getType(num);
			if (num === this.packages[type].num) {
				this.packageI = type;
			} else this.packageI = '';
			let price = this.getPrice(type);
			this.formList.price = price / 1e4;
			this.formList.money = num * 10 * price / 10;
		},
		buy() {
			this.qrCode = '';
			this.btn1Load = false;
			this.dialog1 = true;
		},
		dialogClose() {
			window.clearInterval(timeout);
		},
		ok() {//购买
			window.clearInterval(timeout);
			this.btn1Load = true;
			let getResult = (sms_order_num) => {
				timeout = window.setInterval(() => {
					api.smsOrderStatus({sms_order_num}).then(res => {
						window.clearInterval(timeout);
						this.dialog1 = false;
						this.init();
						this.$notify.success({
							title: '成功',
							message: '支付成功'
						})
					}).catch(err => {
						// getResult(sms_order_num);
					})
					// window.clearTimeout(timeout);
				}, 2e3)
			}
			api.smsPay({buy_num: this.formList.num * 10, service_type: 2}).then(res => {
				api.smsQrCode({code_url: res.code_url}).then(res1 => {//二维码
					this.qrCode = res1;
					this.btn1Load = false;
					getResult(res.sms_order_num);
				})
			}).catch(err => {
				this.$notify({
					type: 'error',
					title: '失败',
					message: err.msg || '购买失败'
				})
				this.btn1Load = false;
			})
		},
		addPhone() {
			this.$refs.formList2.validate(valid => {
				if (!valid) return false;
				let form = this.formList2, arr = form.arrPhone;
				arr.push(form.phone);
				this.formList2.arrPhone = [...new Set(arr)];
			})
		},
		delPhone(i) {
			this.formList2.arrPhone.splice(i, 1);
		},
		save() {
			smsPhone({send_phone: this.formList2.arrPhone.join()}).then(res => {
				this.$notify.success({
					title: '成功',
					message: '保存成功'
				})
				this.formList2.phone = '';
				this.init();
				this.dialog2 = false;
			}).catch(err => {
				this.$notify({
					type: 'error',
					title: '失败',
					message: err.msg || '保存失败'
				})
			})
		},
		getType(num) {//num万条
			let type = 0;
			if (num > 1 && num <= 5) {
				type = 1;
			} else if (num > 5 && num <= 10) {
				type = 2;
			} else if (num > 10 && num <= 50) {
				type = 3;
			} else if (num > 50 && num <= 100) {
				type = 4;
			} else if (num > 100 && num <= 300) {
				type = 5;
			}
			return type;
		},
		getPrice(type) {//单价
			let price = 960;
			switch (type) {
				case 1:
					price = 940;
					break;
				case 2:
					price = 670;
					break;
				case 3:
					price = 620;
					break;
				case 4:
					price = 610;
					break;
				case 5:
					price = 600;
					break;
				case 6:
					price = 590;
					break;
			}
			return price;
		},
		buyLog() {
			this.logType = 0;
			this.listQuery.pageindex = 1;
			this.logList();
		},
		sendLog() {
			this.logType = 1;
			this.listQuery.pageindex = 1;
			this.logList();
		},
		logList() {
			this.listLoading = true;
			if (this.logType === 0) {
				api.smsOrderList(this.listQuery).then(res => {
					this.list = res.list;
					this.total = res.totalcount;
				}).finally(() => {
					this.listLoading = false;
				})
			} else {
				api.smsSendList(this.listQuery).then(res => {
					this.list = res.list;
					this.total = res.totalcount;
				}).finally(() => {
					this.listLoading = false;
				})
			}
		},
		handleSizeChange(val) {
			this.listQuery.pagesize = val;
			this.logList();
		},
		handleCurrentChange(val) {
			this.listQuery.pageindex = val;
			this.logList();
		},
	}
}
</script>
<style>
.container {
	padding: 0 20px;
}

.main {
	display: flex;
}

.main .list {
	flex: 1;
	margin-left: 10px;
}

.top {
	display: flex;
	align-items: center;
	margin: 0 0 20px 0;
}

.qrCode {
	display: flex;
	justify-content: center;
}

.qrCode > img {
	min-width: 300px;
	max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/card/sms.vue